/**
 * Configuration for API endpoints and base URLs
 * 
 * IMPORTANT: Create React App requires the REACT_APP_ prefix for environment variables.
 * This is a security feature - only variables with this prefix are exposed to the browser.
 * 
 * Environment variables for Vercel:
 * - REACT_APP_API_BASE_URL: API base URL (e.g., https://whoseland-map-rafn.onrender.com)
 * - REACT_APP_GOOGLE_MAPS_API_KEY: Google Maps API key
 * - REACT_APP_JAWG_ACCESS_TOKEN: Jawg Maps access token (tiles). Optional; falls back to bundled token if unset.
 * - REACT_APP_JAWG_LIGHT_STYLE_ID: Raster style id for the default “light” base map (Jawg Lab publish id).
 * - REACT_APP_ENTRY_TYPE_SHAPES: set to `0` for an emergency rollback to legacy square markers.
 *   Override in env to point at another style without changing code.
 * 
 * For development, create a .env file with these variables.
 * For production on Vercel, set them in the Vercel dashboard.
 */

const config = {
    // API base URL - used for all API calls
    // Defaults to https://whoseland-map-rafn.onrender.com if not set
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.whoseland.work/',

    // Google Maps API key
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '',

    // DOC-13 rollback seam. Enabled by default; only the explicit string `0`
    // restores the legacy all-square marker treatment.
    ENTRY_TYPE_SHAPES_ENABLED: process.env.REACT_APP_ENTRY_TYPE_SHAPES !== '0',

    // Jawg raster tiles (https://www.jawg.io/docs/apidocs/maps/dynamic-maps/)
    JAWG_ACCESS_TOKEN:
        process.env.REACT_APP_JAWG_ACCESS_TOKEN ||
        'ej0FAN3xWjx5rLGPD2e3roHS4O3SIoZUQjuOTm5e6PJ2sqN1DnAZQRgPmaUP7YjM',
    /** Custom Jawg Light (Lab); raster URL: `https://tile.jawg.io/{id}/{z}/{x}/{y}{r}.png`. */
    JAWG_LIGHT_STYLE_ID:
        process.env.REACT_APP_JAWG_LIGHT_STYLE_ID || '112c45b2-0935-4930-ab6c-3d6c218922d6',

    // Helper function to construct full API URLs
    getApiUrl: (endpoint) => {
        // Remove leading slash if present to avoid double slashes
        const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
        return `${config.API_BASE_URL}/${cleanEndpoint}`;
    },

    // Helper to check if we're in development mode
    isDevelopment: process.env.NODE_ENV === 'development',

    // Helper to check if we're in production mode
    isProduction: process.env.NODE_ENV === 'production',
};

export default config;

